document.addEventListener("DOMContentLoaded", function() {

    $(document).on('click','.build-your-own-box .single_tab',function(){
        var data_id = $(this).attr("data_id");
        $(this).parents(".blocks_content").find(".single_tab").removeClass("active");
        $(this).addClass("active");
        $(this).parents(".blocks_content").find(".single_tab_data").addClass("hidden");
        $(this).parents(".blocks_content").find(".single_tab_data").removeClass("stop_new_add");
        $(this).parents(".blocks_content").find(".single_tab_data[data_id='"+data_id+"'").removeClass("hidden");

        set_zero($(this));
        bundle_data_retrive();
    });

    if($(".build-your-own-box .section_content .tag_list .tag_list_inner .single_tab:first-child").length){
        $(".build-your-own-box .section_content .tag_list .tag_list_inner .single_tab:first-child").click();
    }

    function bundle_data_retrive(){
        if($(".build-your-own-box .build_box_inner .product_list").length){
            $(".build-your-own-box .build_box_inner .product_list").html("");

            var max_pro_select = parseInt($(".build-your-own-box .single_tab_data:not(.hidden)").attr('data_max_products')),
                blank_pro_html = "";

            for (var i = 0; i < max_pro_select; i++){
                blank_pro_html += `
                <div class="single_pro_block">
                    <div class="index">${i+1}</div>
                    <div class="product_data">
                        <div class="img_inner"></div>
                        <div class="title_with_remove small">
                            <div class="pro_title"></div>
                            <div class="remove_btn JS_remove"></div>
                        </div>
                    </div>
                </div>
                `;
            }
            $(".build-your-own-box .build_box_inner .product_list").html(blank_pro_html);
            
            checkout_button_logic();
        }
    }

    $(document).on("click", ".build-your-own-box .single_pro_block .JS_remove", function(){
        var pro_id = $(this).parents(".single_pro_block").attr("pro_id");
        if($(".build-your-own-box .single_tab_data:not(.hidden) .single_product[data_productid='"+pro_id+"']").length){
            $(".build-your-own-box .single_tab_data:not(.hidden) .single_product[data_productid='"+pro_id+"']").find(".qty_btn.minus").click();
        }
    });

    function set_zero(data){
        $(data).parents(".blocks_content").find(".single_tab_data .qty_ATC_inner").addClass("qty_hide");
        $(data).parents(".blocks_content").find(".single_tab_data .qty_val").html(0);
    }

    $(document).on('click','.build-your-own-box .product_list_inner .single_product .atc_btn_JS',function(){
        $(this).parents('.qty_ATC_inner').removeClass('qty_hide');
        $(this).parents('.qty_ATC_inner').find('.qty_btn.plus').click();
    });

    $(document).on('click','.build-your-own-box .single_product .qty_btn',function(){
        if($(this).hasClass('plus')){
            qty_plus($(this));
        }
        if($(this).hasClass('minus')){
            qty_minus($(this));
        }
    });

    function qty_plus(data){
        var qty_val = parseInt($(data).parents('.qty_btn_inner').find('.qty_val').html()),
            inventory_quantity = parseInt($(data).parents('.qty_btn_inner').find('.qty_val').attr('inventory_quantity'));
        qty_val = qty_val + 1;
        $(data).parents('.qty_btn_inner').find('.qty_val').html(qty_val);
        $(data).parents('.qty_btn_inner').find('.qty_val').attr('qty_value',qty_val);
        
        new_product_onoff();

        var pro_id = $(data).parents('.single_product').attr('data_productid'),
            data_price = $(data).parents('.single_product').attr('data_price'),
            data_comp_price = $(data).parents('.single_product').attr('data_comp_price'),
            pro_img_src = $(data).parents('.single_product').find('.product_image img').attr('src'),
            pro_title = $(data).parents('.single_product').find('.pro_title_text').text();
            
        var emptyBlock = $(data).parents('.build-your-own-box').find(".build_box_inner .product_list .single_pro_block").filter(function(){
                            return $(this).find(".img_inner img").length === 0;
                        }).first();
                        
        if(emptyBlock.length){
            emptyBlock.attr("pro_id",pro_id);
            emptyBlock.attr("data_price",data_price);
            emptyBlock.attr("data_comp_price",data_comp_price);
            emptyBlock.find(".img_inner").html(`<img src="${pro_img_src}">`);
            emptyBlock.find(".pro_title").text(pro_title);
            emptyBlock.find(".remove_btn").text("Edit");
        }
        checkout_button_logic();

        if(inventory_quantity == qty_val){
            $(data).parents('.single_product').addClass('stop_new_add');
            return;
        }
    }

    function qty_minus(data){
        var qty_val = parseInt($(data).parents('.qty_btn_inner').find('.qty_val').html()),
            inventory_quantity = parseInt($(data).parents('.qty_btn_inner').find('.qty_val').attr('inventory_quantity'));

        if(qty_val == 1){
            $(data).parents('.qty_ATC_inner').addClass('qty_hide');
        }
        qty_val = qty_val - 1;
        $(data).parents('.qty_btn_inner').find('.qty_val').html(qty_val);
        $(data).parents('.qty_btn_inner').find('.qty_val').attr('qty_value',qty_val);
        new_product_onoff();

        var pro_id = $(data).parents('.single_product').attr('data_productid'), 
            blockToRemove = $(data).parents('.build-your-own-box').find(".build_box_inner .product_list .single_pro_block[pro_id='"+pro_id+"']").last();

        if(blockToRemove.length){
            blockToRemove.removeAttr("pro_id");
            blockToRemove.removeAttr("data_price");
            blockToRemove.removeAttr("data_comp_price");
            blockToRemove.find(".img_inner").html("");
            blockToRemove.find(".pro_title").text("");
            blockToRemove.find(".remove_btn").text("");
        }
        
        checkout_button_logic();
        

        if(inventory_quantity > qty_val && $(data).parents('.single_product').hasClass('stop_new_add')){
            $(data).parents('.single_product').removeClass('stop_new_add');
        }
    }

    function new_product_onoff(){
        $('.build-your-own-box .single_tab_data').each(function() {
            var max_pro_select = parseInt($(this).attr('data_max_products')),
                qty_value = 0;
            
            $(this).find('.qty_val').each(function(){
                qty_value = qty_value + parseInt($(this).attr('qty_value'));
            });
            
            if(qty_value == max_pro_select){
                $(this).addClass('stop_new_add');                
            }else{
                $(this).removeClass('stop_new_add');
            }
        });
    }

    function checkout_button_logic(){
        var max_pro_select = parseInt($(".build-your-own-box .single_tab_data:not(.hidden)").attr('data_max_products')),
            pack_price = parseInt($(".build-your-own-box .single_tab_data:not(.hidden)").attr('data_pack_price')),
            selected_pro_blocks = $(".build-your-own-box .build_box_inner .product_list [pro_id]"),
            selected_pro = $(".build-your-own-box .build_box_inner .product_list [pro_id]").length,
            checkoutURL = `javascript:void(0)`,
            data_price = 0;
            data_comp_price = 0;
            
        if(selected_pro == max_pro_select){
            var checkoutItems = [];
            selected_pro_blocks.each(function(){
                var pro_id = parseInt($(this).attr("pro_id"));
                checkoutItems.push(`${pro_id}:1`);
            });
            
            checkoutURL = `/cart/${checkoutItems.join(",")}`;
            $(".build-your-own-box .build_box_inner .checkout_button").removeClass('disabled');
            $(".build-your-own-box .build_box_inner .checkout_button").html(`Proceed To Checkout`);
        }else{
            $(".build-your-own-box .build_box_inner .checkout_button.desktop").html(`${selected_pro} / ${max_pro_select} Selected`);
        }

        $(".build-your-own-box .build_box_inner .checkout_button.mobile").html(`Proceed To Checkout - <span class="price_JS"></span>`);
        // $(".build-your-own-box .build_box_inner .checkout_button").attr('href',checkoutURL);

        if($(".build-your-own-box .build_box_inner .total_added_items").length){
            $(".build-your-own-box .build_box_inner .total_added_items").html(`${selected_pro} / ${max_pro_select}`);
        }

        selected_pro_blocks.each(function(){
            data_price += parseInt($(this).attr("data_price"));
            data_comp_price += parseInt($(this).attr("data_comp_price"));
        });

        var sell_price = Shopify.formatMoney(data_price, document.querySelector("body").getAttribute("money_format")),
            comp_price = Shopify.formatMoney(data_comp_price, document.querySelector("body").getAttribute("money_format"));

        if(selected_pro == max_pro_select){
            if(max_pro_select == 3){
                sell_price = Shopify.formatMoney(89900, document.querySelector("body").getAttribute("money_format"));
            }else if(max_pro_select == 5){
                sell_price = Shopify.formatMoney(139900, document.querySelector("body").getAttribute("money_format"));
            }else if(max_pro_select == 7){
                sell_price = Shopify.formatMoney(189900, document.querySelector("body").getAttribute("money_format"));
            }
            sell_price = Shopify.formatMoney(pack_price, document.querySelector("body").getAttribute("money_format"));
        }

        var price_html = ` <span class="sell_price">${sell_price}</span><del>${comp_price}</del>`;
        if($(".build_box_content .price_JS").length){
            $(".build_box_content .price_JS").html(price_html);
        }
    }

    if($(".build-your-own-box").length){
        $(".build-your-own-box").removeClass("hidden");
    }

    if($(window).width() <= 749){
        if($(".build-your-own-box .box_content_with_footer").length){
            $(".build-your-own-box .box_content_with_footer").css("display","none");
        }
        
        $(document).on('click','.build-your-own-box .build_box_inner .box_header',function(){
            $(this).toggleClass("active");
            $(this).parents(".build_box_inner").find(".box_content_with_footer").slideToggle(250);
        });
    }

    $(document).on('click', '.js_checkout_button', function(e){
        e.preventDefault();
        var _this = $(this),
            add_products = [];

        if(_this.hasClass('disabled')){
            return false;
        }

        $('.build-your-own-box .single_tab_data:not(.hidden) .product_list_inner .single_product').each(function(index, single_product){
            let variant_id = parseInt($(single_product).attr('data_productid')),
                qty = parseInt($(single_product).find('.qty_val').attr('qty_value'));
            if(qty >= 1){
                add_products.push({id: variant_id, quantity: qty, properties: { _bundle: 'yes' }});
            }
        });

        let add_formData = {
            'items': add_products
        }

        if(add_products.length > 0){
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(add_formData),
                success:function(data, textStatus, jqXHR){
                    if (jqXHR.status === 200) {
                        window.location.href = '/checkout';
                    }
                },
                error:function(error){
                    alert(error.responseJSON.description);
                }
            });
        }
    });

});